import { createContext, useState, useCallback, useContext, useEffect } from "react";
import { onDisabledScrollHandler, onEnableScrollHandler } from "../utils/ScrollHandler";
import SendGTAGEvent from "../utils/sendGTAGEvent";

interface ISearchProps {
    onOpenCloseSearchHandler: () => void;
    isOpenSearch: boolean;
    showButtonSearch: boolean;
    onShowButtonSearchHandler: (isShow: boolean) => void;
    widthWindow: number;
}

export const SearchContext = createContext({} as ISearchProps)

const SearchContextProvider: React.FC = ({ children }) => {
    const [isOpenSearch, setIsOpenSearch] = useState<boolean>(false)
    const [showButtonSearch, setShowButtonSearch] = useState<boolean>(false)
    const [widthWindow, setWidthWindow] = useState(window.innerWidth)

    const onOpenCloseSearchHandler = useCallback(() => setIsOpenSearch(prevState => {
        if (prevState) {
            onEnableScrollHandler()
        } else {
            onDisabledScrollHandler()
            SendGTAGEvent(
                'botao_pesquisar',
                'Pesquisa',
                'Abriu aba de pesquisa',
            )
        }
        return !prevState
    }), [])
    const onShowButtonSearchHandler = useCallback((isShow: boolean) => setShowButtonSearch(isShow), [])

    useEffect(() => {
        window.addEventListener('resize', () => setWidthWindow(window.innerWidth))
        return () => {
            window.removeEventListener('resize', () => setWidthWindow(window.innerWidth))
        }
    }, [])

    return (
        <SearchContext.Provider value={{
            isOpenSearch,
            onOpenCloseSearchHandler,
            showButtonSearch,
            onShowButtonSearchHandler,
            widthWindow
        }}>
            {children}
        </SearchContext.Provider>
    )
}

const useSearch = () => {
    const { isOpenSearch, onOpenCloseSearchHandler, showButtonSearch, onShowButtonSearchHandler, widthWindow } = useContext(SearchContext)
    return { isOpenSearch, onOpenCloseSearchHandler, showButtonSearch, onShowButtonSearchHandler, widthWindow }
}

export default useSearch

export { SearchContextProvider }